<template>
  <v-layout>
    <div class="padding-container-sm">
      <div class="header">
        <span slot="header">
          <div class="row">
            <div class="col col-md-12 p-5 progress-view">
              <v-tab :tabProps="tabProps" @activeTab="activeTab">
                <div slot="alerts"  v-if="this.tabProps.activeTabName === 'Alerts'">
                  <v-alerts :status="'UnResolved'"/>
                </div>
                <div slot="alertsResolved" v-if="this.tabProps.activeTabName === 'AlertsResolved'">
                  <v-alerts :status="'Resolved'"/>
                </div>
                <div
                  slot="followUps"
                  v-if="this.tabProps.activeTabName === 'Follow ups'"
                >
                  <v-follow-ups :status="'UnResolved'"/>
                </div>
                <div slot="followUpsResolved" v-if="this.tabProps.activeTabName === 'FollowUpsResolved'">
                  <v-follow-ups :status="'Resolved'"/>
                </div>
              </v-tab>
            </div>
          </div>
        </span>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from "@/layouts/Default.vue";
import VTab from "@/components/tab/tab.vue";
import VAlerts from "@/components/alerts/index.vue";
import VFollowUps from "@/components/followUps/index.vue";
import { mapGetters } from "vuex";

export default {
  name: "AlertsView",
  components: {
    VLayout,
    VTab,
    VAlerts,
    VFollowUps
  },

  data() {
    return {
      tabProps: {
        tabs: [],
        activeTabName: null,
        currentUser: this.currentUser
      },
      allTabs: [
        {
          title: "Alerts",
          slot: "alerts"
        },
        {
          title: "AlertsResolved",
          slot: "alertsResolved"
        },
        {
          title: "Follow ups",
          slot: "followUps"
        },
        {
          title: "FollowUpsResolved",
          slot: "followUpsResolved"
        }
      ],
      followUpTab: [
        {
          title: "Follow ups",
          slot: "followUps"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/getUser"
    })
  },
  watch: {
    currentUser: {
      immediate: true,
      handler: "onCurrentUserChange"
    }
  },
  methods: {
    activeTab(name) {
      this.tabProps.activeTabName = name;
    },
    onCurrentUserChange() {
      if (this.currentUser) {
        this.tabProps.tabs =
          this.currentUser.designation === "CARE_NAVIGATOR"
            ? this.allTabs
            : this.followUpTab;
        this.tabProps.activeTabName = this.tabProps.tabs[0].title;
      }
    }
  }
};
</script>
